import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { activityApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { CreateActivityFormData, CreateActivityResponse } from '../types/activity';

/**
 * Hook to create a new activity with cache invalidation
 * @returns Mutation object with mutate function and state
 */
export function useCreateActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: CreateActivityFormData) => {
      return activityApi.createActivity(formData);
    },

    onSuccess: (data: CreateActivityResponse) => {
      // Invalidate activities list to include the new activity
      queryClient.invalidateQueries({
        queryKey: queryKeys.activities.lists(),
      });

      toast.success('Activity created successfully!');
      
      return data;
    },

    onError: (error: Error) => {
      const message = error.message || 'Failed to create activity';
      toast.error(message);
    },
  });
}
